import { Icon, Skeleton, Text, Tooltip } from ".."
import { Space } from "antd"
import PropTypes from "prop-types"

const IconText = ({
  className,
  children,
  icon,
  iconProps = {},
  title,
  gap = 8,
  textType,
  loading = false,
  loadingProps = {},
  message,
  titleProps = {},
  fontSize,
  handleTextClick,
  style,
  wrapText = true,
  ...rest
}) => {
  const containerStyle = {
    gap: gap,
    flexDirection: iconProps.placement === "end" ? "row-reverse" : "",
    ...(wrapText === false && {
      display: "flex",
      alignItems: "center",
      width: "100%",
      minWidth: 0,
      overflow: "hidden",
    }),
    ...style,
  }

  const textStyle = {
    "--ant-font-size": fontSize,
    cursor: handleTextClick ? "pointer" : "default",
  }

  const renderIcon = () => {
    if (!icon) return null

    if (loading) {
      return <Skeleton type="avatar" size={loadingProps.avatarSize || "small"} />
    }

    return (
      <Icon
        icon={icon}
        size={iconProps.size}
        color={iconProps.color}
        hasBackground={iconProps.hasBackground}
        {...iconProps}
      />
    )
  }

  const renderText = () => {
    // if (loading) {
    //   return <Skeleton type="title" size={loadingProps.rectSize || "small"} />
    // }

    if (wrapText === false) {
      return (
        <div
          style={{
            flex: 1,
            minWidth: 0,
            overflow: "hidden",
            whiteSpace: "nowrap",
            textOverflow: "ellipsis",
          }}
        >
          <Text
            style={textStyle}
            type={textType}
            {...titleProps}
            onClick={handleTextClick}
            loading={loading}
            loadingProps={loadingProps}
          >
            {children || title}
          </Text>
        </div>
      )
    }

    return (
      <Text
        style={textStyle}
        type={textType}
        {...titleProps}
        onClick={handleTextClick}
        loading={loading}
        loadingProps={loadingProps}
      >
        {children || title}
      </Text>
    )
  }

  const content =
    wrapText === false ? (
      <div className={className} style={containerStyle} {...rest}>
        {renderIcon()}
        {renderText()}
      </div>
    ) : (
      <Space className={className} size={gap} style={containerStyle} {...rest}>
        {renderIcon()}
        {renderText()}
      </Space>
    )

  if (message) {
    return (
      <Tooltip placement="topLeft" title={message}>
        {content}
      </Tooltip>
    )
  }

  return content
}

IconText.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  icon: PropTypes.string,
  iconProps: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  textType: PropTypes.string,
  gap: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  loading: PropTypes.bool,
  loadingProps: PropTypes.object,
  message: PropTypes.string,
  titleProps: PropTypes.object,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  handleTextClick: PropTypes.func,
  style: PropTypes.object,
  wrapText: PropTypes.bool,
}

IconText.defaultProps = {
  icon: null,
  iconProps: { size: "1em" },
  loadingProps: { avatarSize: "small", rectSize: "small" },
  title: "title",
  gap: 8,
  loading: false,
  titleProps: {},
  wrapText: true,
}

export default IconText
